
type Props = {
  pdfPath: string,
}

export const TermsOfService = ({ pdfPath }: Props) => <iframe
  src={pdfPath}
  width="100%"
  height="100%"
  title="PDF Viewer"
  style={{ border: 'none' }}
/>